import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const HeaderString = ({ value, color }) => (
  <div className={`header-string header-string--${color}`}>{value}</div>
);

HeaderString.propTypes = {
  value: PropTypes.string,
  color: PropTypes.string,
};

HeaderString.defaultProps = {
  value: '',
  color: 'gold',
};

export default HeaderString;
